import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import moment from 'moment';

import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../components';

import { getApiSetting, saveApiSetting } from '../../../redux/actions/siteActions';

let isLoading = "false";
class CartSetting extends Component {
  constructor(props){
    super(props);
    this.state = {
      path: ['Home', 'Cart Setting'], 
      links: ["home",'/cart-setting'],
      fb_app_id: '',
      fb_shared_id: '',
      fb_secret_key: '',
      google_map_key: '',
      show: false,
      alertMessage: '',
      msgType: '',
      clear_cart:'',
      cart_time:'0',
      cart_hours:'',
      couponLogin:'Disable',
      affiliateLogin:'Disable',
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  handleDismiss(){
  	this.setState({
  		show: false,
  		alertMessage: '',
  		msgType: '',
  	});
  }

  componentWillMount(){
    this.handPageChange();
  }

  handPageChange(){
  	isLoading = "true";
  	this.props.getApiSetting();
  }
  componentWillReceiveProps(nextProps){ 
  	if(this.props.apiDetail !== nextProps.apiDetail){
  		if(nextProps.apiDetail){
  			if(nextProps.apiDetail.data){
  				this.setState({
  					fb_app_id: nextProps.apiDetail.data.fb_app_id,
  			    fb_shared_id: nextProps.apiDetail.data.fb_shared_id,
  			    fb_secret_key: nextProps.apiDetail.data.fb_secret_key,
  			    google_map_key: nextProps.apiDetail.data.google_map_key,
            clear_cart: nextProps.apiDetail.data.clear_cart,
            cart_time: (nextProps.apiDetail.data.clear_cart=='day' ? nextProps.apiDetail.data.clear_cart_duration : ''),
            cart_hours: ((nextProps.apiDetail.data.clear_cart=='hour'  || nextProps.apiDetail.data.clear_cart=='deletehour')? nextProps.apiDetail.data.clear_cart_duration : ''),
            couponLogin: nextProps.apiDetail.data.couponLogin,
            affiliateLogin: nextProps.apiDetail.data.affiliateLogin,
  				});
  			}
  			isLoading = "false";
  		}
  	}

  	if(this.props.settingStatus !== nextProps.settingStatus){
  		if(nextProps.settingStatus){
  			this.setState({
  		  		show: true,
  		  		alertMessage: nextProps.settingStatus.message,
  		  		msgType: 'success',
  		  });

  			this.handPageChange();
		  }
  	}

  	if(this.props.error !== nextProps.error){
  		if(nextProps.error){
  			this.setState({
  		  		show: true,
  		  		alertMessage: nextProps.error.message,
  		  		msgType: 'danger',
  		  	});

  			this.handPageChange();
  		}
  	}
  }

  handleChange = (e) => {
  	if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
  	this.setState({[e.target.name] : e.target.value })
  }

  validate = (e) => {
    let isError = true; 

    if(this.state.clear_cart=='hour'){
      if(!this.state.cart_hours){
        this.setState({cart_hoursError : 'red'});
        isError = false;
      }
    }
    else if(this.state.clear_cart=='day'){
      if(this.state.cart_time==''){
        this.setState({cart_timeError : 'red'});
        isError = false;
      }
    }

    return isError;
  }

  handleSubmit = (e) => {

    e.preventDefault();
    let isError = this.validate();
    if(isError){
      const constData = {
        fb_app_id: this.state.fb_app_id,
        fb_shared_id: this.state.fb_shared_id,
        fb_secret_key: this.state.fb_secret_key,
        google_map_key: this.state.google_map_key,
        clear_cart: this.state.clear_cart,
        cart_hours: (this.state.clear_cart=='hour' || this.state.clear_cart=='deletehour') ? this.state.cart_hours : '',
        cart_time: (this.state.clear_cart=='day' ? this.state.cart_time : ''),
        couponLogin: this.state.couponLogin,
        affiliateLogin: this.state.affiliateLogin,
      }
      isLoading = "true";
      this.props.saveApiSetting(constData);
    }
  }

  render() { 
    const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    const listoption = numbers.map((number) =>
      <option key={number < 10 ? '0'+number.toString() : number.toString()} value={number}>
        {number > 12 ? (number-12) : number} {number > 11 ? 'PM' : 'AM'}
      </option>
    );
  return (
    <div className="col-lg-12 add-sub-admin">
    {isLoading == "true" ? (
      <div className="loader">
        <p className="loading-message">
          <i>Loading...</i>
        </p>
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>
    ) : (
      ""
    )}
    <div className="row">
      <div className="col-xs-12">
         <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
      </div>
    </div>
    <form>
      <div className="panel">
          <header className="panel-heading">Cart Setting</header>
          <div className="panel-body">
          {this.state.show && this.state.alertMessage !=='' &&  
          	<Row>      
              <Col md={12} xs={12}>
                <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
              </Col>
            </Row>
          }
          <Row>
            <Col md={6} xs={6}>
              <FormGroup>
                <ControlLabel>Clear Cart:</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="clear_cart"
                  value={this.state.clear_cart}
                  onChange={this.handleChange}
                >
                  <option value="never">Never Clear Cart</option>
                  <option value="hour">Clear Cart each </option>
                  <option value="day">Clear Cart at </option>
                    <option value="deletehour">Unpaid  Cart delete at </option>
                </FormControl>
              </FormGroup>
            </Col>

            {(this.state.clear_cart=='hour' || this.state.clear_cart=='deletehour' ) && 
              <Col md={6} xs={6}>
                <FormGroup>
                  <ControlLabel>&nbsp;</ControlLabel>
                  <FormGroup as={Row}>
                    <Col sm={3}>
                      <FormControl 
                        type="number"
                        name="cart_hours"
                        value={this.state.cart_hours}
                        onChange={this.handleChange}
                        max={24}
                        min={1}
                        style={{borderColor:this.state.cart_hoursError}}
                      />
                    </Col>
                    <Col sm={9}>
                      Hours
                    </Col>  
                  </FormGroup>
                </FormGroup>
              </Col>
            }
            {(this.state.clear_cart=='day') && 
              <Col md={6} xs={6}>
                <FormGroup>
                  <ControlLabel>&nbsp;</ControlLabel>
                  <FormGroup as={Row}>
                    <Col sm={3}>
                      <FormControl 
                        componentClass="select"
                        name="cart_time"
                        value={this.state.cart_time}
                        onChange={this.handleChange}
                        style={{borderColor:this.state.cart_timeError}}
                      >
                      {listoption}
                      </FormControl>
                    </Col>
                    <Col sm={9}>
                      each day
                    </Col>  
                  </FormGroup>
                </FormGroup>
              </Col>
            }

          </Row>
          <Row>
            <Col md={6} xs={6}>
              <FormGroup>
                <ControlLabel>Require User Login For Free Coupon Offers</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="couponLogin"
                  value={this.state.couponLogin}
                  onChange={this.handleChange}
                >
                  <option value="Enable">Enable</option>
                  <option value="Disable">Disable</option> 
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6} xs={6}>
              <FormGroup>
                <ControlLabel>Require User Login For Affiliate  Offers</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="affiliateLogin"
                  value={this.state.affiliateLogin}
                  onChange={this.handleChange}
                >
                  <option value="Enable">Enable</option>
                  <option value="Disable">Disable</option> 
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <Row><hr/></Row>
          <Row>
            <Col md={12} xs={12}>
              <Button bsStyle="success" className="pull-right" onClick={this.handleSubmit}>Save</Button>
            </Col>
          </Row>
          </div>
      </div>
    </form>
    </div>
  )
  }
}

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.siteReducer.error,
      apiDetail:  state.siteReducer.apiDetail,
      settingStatus:  state.siteReducer.settingStatus,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {getApiSetting, saveApiSetting})
)(CartSetting);



// WEBPACK FOOTER //
// ./src/app/views/admin/setting/CartSetting.js